import { render } from "./InOutColumnOld.vue?vue&type=template&id=6953ac32"
import script from "./InOutColumnOld.vue?vue&type=script&lang=js"
export * from "./InOutColumnOld.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__